import script from "./NewExp.vue?vue&type=script&setup=true&lang=js"
export * from "./NewExp.vue?vue&type=script&setup=true&lang=js"

import "./NewExp.vue?vue&type=style&index=0&id=1cc11d63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc11d63"]])

export default __exports__